import { Component, contentChild, input, output, TemplateRef } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "sxw-overlay-menu-list",
  imports: [TranslatePipe, NgTemplateOutlet],
  templateUrl: "./overlay-menu-list.component.html",
  styleUrl: "./overlay-menu-list.component.scss",
  host: {
    class: "overlay",
  },
})
export class OverlayMenuListComponent<T extends object> {
  title = input<string>();

  items = input<T[]>([]);
  dataKey = input.required<keyof T>();
  emptyMessage = input<string>();

  itemClicked = output<T>();

  menuItemContent = contentChild.required<TemplateRef<{ item: T; index: number }>>("menuItem", { descendants: false });
  emptyMessageContent = contentChild<TemplateRef<void>>("emptyMessage", { descendants: false });
}
